import { ActivityGroupProps } from '~/bootcamp/Activities/types/activities.types'

import LatticeDecimal from './LongMulti/LatticeDecimal'
import LatticeInteger from './LongMulti/LatticeInteger'
import LongMulti1 from './LongMulti/LongMulti1'
import LongMulti2 from './LongMulti/LongMulti2'
import LongMultiDecimal from './LongMulti/LongMultiDecimal'
import LongMultiDecimalThreeDigits from './LongMulti/LongMultiDecimalThreeDigits'
import LongMultiDecimalThreeDigits2 from './LongMulti/LongMultiDecimalThreeDigits2'
import LongMultiDecimalTwoDigits from './LongMulti/LongMultiDecimalTwoDigits'
import LongMultiThreeDigit from './LongMulti/LongMultiThreeDigit'
import LongMultiTwoDigit from './LongMulti/LongMultiTwoDigit'
import Distributive from './TwoDigits/Distributive'
import MultiByTwoDigit from './TwoDigits/MultiByTwoDigit'

const Bootcamp3Activities = ({ activityName, ...props }: ActivityGroupProps): React.ReactElement => {
  switch (activityName) {
    case 'LongMulti1':
      return <LongMulti1 {...props} />
    case 'LongMulti2':
      return <LongMulti2 {...props} />
    case 'LongMultiTwoDigit':
      return <LongMultiTwoDigit {...props} />
    case 'LongMultiThreeDigit':
      return <LongMultiThreeDigit {...props} />
    case 'LongMultiDecimal':
      return <LongMultiDecimal {...props} />
    case 'LongMultiDecimalTwoDigits':
      return <LongMultiDecimalTwoDigits {...props} />
    case 'LongMultiDecimalThreeDigits':
      return <LongMultiDecimalThreeDigits {...props} />
    case 'LongMultiDecimalThreeDigits2':
      return <LongMultiDecimalThreeDigits2 {...props} />
    case 'LatticeInteger':
      return <LatticeInteger {...props} />
    case 'LatticeDecimal':
      return <LatticeDecimal {...props} />
    case 'Distributive':
      return <Distributive {...props} />
    case 'MultiByTwoDigit':
      return <MultiByTwoDigit {...props} />
    default:
      return <></>
  }
}

export default Bootcamp3Activities
